import React, { Suspense, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import ListEmpty from '../components/fragments/ListEmpty';
import DevBanner from '../components/utilities/DevBanner';
import Routes from './Routes';
import { rtGetListData } from '../store/slices/listSlice';

function App() {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(rtGetListData('churches', 'churches', true));
    }, [dispatch]);

    return (
        <Suspense fallback={<ListEmpty title="Loading" />}>
            <DevBanner />
            <Routes />
        </Suspense>
    );
}

export default App;
